<template>
  <div class="tarjeta-envoltorio">
    <v-card class="ma-1 tarjeta" :class="{ 'tarjeta--agotada': agotado }" outlined hover @click="selectProduct" :disabled="!hasPrice()"
      :title="'REF:' + item.reference + ' - ' + item.name">
      <div class="tarjeta__imagen">
        <v-img height="100%" width="100%" :src="getPathProduct(item)" contain :class="{ 'tarjeta__sin-foto': !containsImage(item) }"></v-img>
        <v-chip v-if="item.reference" small label class="tarjeta__ref">Ref. {{ item.reference }}</v-chip>
        <v-chip v-if="agotado" small label color="red darken-1" dark class="tarjeta__estado">Agotado</v-chip>
        <v-chip v-else-if="enOrden() > 0" small label color="primary darken-2" dark class="tarjeta__estado">
          <v-icon x-small left>mdi-check-circle</v-icon>{{ enOrden() }} en la orden
        </v-chip>
      </div>
      <div class="tarjeta__cuerpo">
        <div class="tarjeta__nombre">{{ item.name }}</div>
        <div class="tarjeta__principio" v-if="principioActivo"><v-icon x-small color="teal darken-2">mdi-flask-outline</v-icon> {{ principioActivo }}</div>
        <div class="tarjeta__precio">{{ $filters.currency($pos.getSalePrice(this.item, 0, getPriceListId()), 0) }}</div>
      </div>
      <v-card-actions class="pt-0 px-3 pb-3">
        <v-btn block depressed small color="primary" dark class="tarjeta__boton"><v-icon small left class="tarjeta__icono">mdi-basket-plus-outline</v-icon><span class="tarjeta__texto">Añadir al pedido</span></v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { esAgotado } from "@/plugins/pos/agotados";

export default {
  name: 'ProductCard',
  components: {},
  computed: {
    // En una droguería, lo que lleva el medicamento: el cliente suele preguntar por eso.
    principioActivo() {
      const m = this.$store.getters.isDrugStore && this.item.info_medication;
      return (m && m.active_ingredient) || "";
    },
    agotado() {
      return esAgotado(this.item.id);
    },
  },
  data: () => ({
    prices: null
    //isVisible: false
  }),
  props: ['item', 'priceList'],
  /* mounted(){
   },	*/
  methods: {
    selectProduct() {
      if (this.hasPrice()) {
        if(this.item){
          if(this.item.has_batch){
            this.$emit('select:product', this.item)
          } else{
            this.$emit('select:product-batch', this.item)
          }
        }
      }
    },
    hasPrice() {
      return this.$pos.getSalePrice(this.item, 0, this.getPriceListId()) > 0;
    },
    getPriceListId() {
      if (this.priceList) {
        return this.priceList.id
      }
      return null
    },
    getPathProduct(item) {
      if (item && this.$store.state.shared && this.$store.state.shared.company) {
        //return this.$http.getBaseUrlImagesProducts() + this.$store.state.shared.company.id + '/' + item.image;
        if (item.image) {
          return this.$http.getBaseUrlImagesProducts() + '' + item.image;
        }
      }
      return '/assets/product-bag-shade.png';
    },
    enOrden() {
      void this.$store.getters.orderChanged;
      const orden = this.$pos.getCurrentOrder();
      let total = 0;
      for (const linea of (orden && orden.data_items) || []) {
        if (linea.product && linea.product.id === this.item.id) {
          total += parseFloat(linea.quantity) || 0;
        }
      }
      return total;
    },
    containsImage(item){
      if (item && this.$store.state.shared && this.$store.state.shared.company) {
        if (item.image) {
          return true;
        }
      }
      return false;
    }
    /*visibilityChanged(isVisible, entry){
      this.isVisible = isVisible
    }*/
  }
}
</script>
<style scoped>
.tarjeta { overflow: hidden; border-radius: 10px; transition: box-shadow 0.15s; }
.tarjeta--agotada { opacity: 0.55; }
.tarjeta__imagen { position: relative; height: 110px; background: #eaf1f7; display: flex; align-items: center; justify-content: center; }
.tarjeta__sin-foto { opacity: 0.45; padding: 14px; }
.tarjeta__boton { letter-spacing: 0 !important; padding: 0 6px !important; min-width: 0 !important; max-width: 100%; }
.tarjeta__boton >>> .v-btn__content { white-space: nowrap; overflow: hidden; }
.tarjeta__ref { position: absolute; top: 8px; left: 8px; font-weight: 600; background: #fff !important; }
.tarjeta__estado { position: absolute; bottom: 8px; right: 8px; }
.tarjeta__cuerpo { padding: 10px 12px 6px; }
.tarjeta__nombre { font-size: 0.95rem; font-weight: 600; line-height: 1.25; height: 2.5em; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; color: rgba(0, 0, 0, 0.8); }
.tarjeta__principio { margin-top: 2px; font-size: 0.78rem; line-height: 1.2; color: rgba(0, 0, 0, 0.6); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tarjeta__precio { margin-top: 6px; font-size: clamp(1rem, 10.5cqw, 1.5rem); font-weight: 800; line-height: 1.1; color: var(--pos-azul-marino); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
/* La tarjeta se adapta a su propio ancho (con el menú lateral abierto quedan angostas): el precio baja de tamaño
   y, si ni así cabe «Añadir al pedido», el botón queda sólo con el ícono. */
.tarjeta-envoltorio { container-type: inline-size; min-width: 0; }
.tarjeta__boton >>> .v-btn__content { justify-content: center; width: 100%; }
@container (max-width: 190px) {
  .tarjeta__texto { display: none; }
  .tarjeta__icono { margin: 0 !important; }
}
</style>
